import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TablePagination,
  Paper,
} from "@mui/material";
import MUITable from "../../../../Common/MUITable";
import { TableLoader } from "../../../../Common/ShimmerLoader";
import { useEffect } from "react";
import { AttendanceFilterForm } from "../../Attendance/AttendanceSummaryReport/AttendanceFilterForm";
import { useAttendanceStore } from "../../Attendance/AttendanceSummaryReport/store/useAttendanceStore";
import { TonnageCompositionFilter } from "./TonnageCompositionFilter";
import { useMonthWiseAttendanceStore } from "../../Attendance/MonthWiseAttendanceSummary/MonthWiseAttendanceStore";
import isGHMC from "../../../../Common/helper/helpar";

const TonnageCompositionReport = () => {
  const { fetchSupportingStaffDetails } = useAttendanceStore();
      const { MonthWiseAttendanceData, isLoading, fetchMonthWiseAttendanceReport, updateEmployeeAttendanceStatus, isUpdating } =
          useMonthWiseAttendanceStore();
  const navigate = useNavigate();
  const {
    isFetchingAttendanceReport,
    attendanceReport, // Get attendance data
    fetchAttendanceReport, // Fetch API data
    fetchZoneLevelDetails,
  } = useAttendanceStore();
  const filters = JSON.parse(localStorage.getItem("attendance-summary-filters"));

  const isProd = isGHMC();
  const headerStyles = {
    textAlign: "center",
    border: "1px solid #ddd",
    borderRight: "none",
    padding: "10px",
    color: "#fff",
    backgroundColor: isProd ? "#043555" : "#EC1117",
};
const cellStyles = {
    textAlign: "center",
    border: "1px solid #ddd",
    borderRight: "none",
    padding: "10px",
    whiteSpace: "normal",
};


  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <TonnageCompositionFilter />
            <div className="page-header text-start">
              <div className="card">
                <div className="card-body">
                  <div className="top-header d-flex justify-content-center align-items-center">
                    <span>Tonnage Composition Report</span>
                  </div>
                  {/* <AttendanceFilterForm /> */}
                  <TableContainer
                    component={Paper}
                    sx={{
                      width: "100%",
                      border: "1px solid #ccc",
                      maxHeight: 700,
                    }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead
                        className={`${isProd ? "bg-ghmc" : "bg-swm"}`}
                        style={{ position: "sticky", top: 0 }}
                      >
                        <TableRow>
                          <TableCell rowSpan={2} sx={headerStyles}>S.No</TableCell>
                          <TableCell rowSpan={2} sx={headerStyles}>Date</TableCell>
                          <TableCell rowSpan={2} sx={headerStyles}>TS/SCTP</TableCell>
                          <TableCell colSpan={4} sx={headerStyles} style={{ textAlign: "center" }}>
                            Incoming
                          </TableCell>
                          <TableCell colSpan={4} sx={headerStyles} style={{ textAlign: "center" }}>
                            Outgoing
                          </TableCell>
                          <TableCell rowSpan={2} sx={headerStyles}>Actual MT</TableCell>
                          <TableCell rowSpan={2} sx={headerStyles}>Variance</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={headerStyles}>SAT Trips</TableCell>
                          <TableCell sx={headerStyles}>Secondary</TableCell>
                          <TableCell sx={headerStyles}>Others</TableCell>
                          <TableCell sx={headerStyles}>Estimated Tonnage</TableCell>
                          <TableCell sx={headerStyles}>HKL</TableCell>
                          <TableCell sx={headerStyles}>RCV</TableCell>
                          <TableCell sx={headerStyles}>PVT Tech</TableCell>
                          <TableCell sx={headerStyles}>Est MT</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {MonthWiseAttendanceData?.map((item, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              backgroundColor: index % 2 === 1 ? "rgba(4, 53, 85, 0.04)" : "#ffffff",
                            }}
                          >
                            <TableCell sx={cellStyles}>{index + 1}</TableCell>
                            <TableCell sx={cellStyles}>{item.date}</TableCell>
                            <TableCell sx={cellStyles}>{item.hmswTonnage}</TableCell>
                            <TableCell sx={cellStyles}>{item.ghmcTonnage}</TableCell>
                            <TableCell sx={cellStyles}>{item.totalTonnage}</TableCell>
                            <TableCell sx={cellStyles}>{item.hmswTippingFee}</TableCell>
                            <TableCell sx={cellStyles}>{item.ghmcTippingFee}</TableCell>
                            <TableCell sx={cellStyles}>{item.totalAmount}</TableCell>
                            <TableCell sx={cellStyles}>{item.totalAmount}</TableCell>
                            <TableCell sx={cellStyles}>{item.totalAmount}</TableCell>
                            <TableCell sx={cellStyles}>{item.totalAmount}</TableCell>
                            <TableCell sx={cellStyles}>{item.totalAmount}</TableCell> 
                            <TableCell sx={cellStyles}>{item.totalAmount}</TableCell>
                          </TableRow>
                        ))}
                        <TableRow>
                          {/* <TableCell sx={cellStyles} colSpan={2}><strong>Total</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalHMSW}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalGHMC}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalTonnage}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalHMSWTipping}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalGHMCTipping}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalAmount}</strong></TableCell> */}
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TonnageCompositionReport;